
import { inject, reactive, ref, type Ref } from "vue";

export const IdentitySymbol = Symbol();

export interface IIdentity {
  IsAuthenticated: boolean
  DisplayName: string
  Token: string;
  Claims: ITokenClaims;
  SetIdentity(displayName: string, token: string):void;
  Discard(): void;

  IsAdmin: boolean;
  IsBerater: boolean;
  IsAuditor: boolean;

  HasSelectedStandort: boolean;
}

export interface ITokenClaims {
  standortId: string,
  container: string,
  role: string,
  nameid: string,
  exp: Date
}

export class Identity implements IIdentity {
  private _isAuthenticated: Ref<boolean>;
  private _displayName: string;
  private _token: string;
  private _claims: ITokenClaims;

  constructor() {
    this._isAuthenticated = ref(false);
    this._displayName = null;
    this._token = null;
    this._claims = null;

    this.readLocal();
  }

  private storeLocal = (): void => {
    localStorage.setItem("identity", JSON.stringify({
      token: this.Token,
      displayName: this.DisplayName,
    }));
  }

  private readLocal = (): void => {
    if (localStorage.hasOwnProperty("identity")) {
      const storedIdentity = JSON.parse(localStorage.getItem("identity"));

      this._token = storedIdentity.token;
      this.SetClaims(storedIdentity.token);

      this._isAuthenticated = ref(true);
      this._displayName = storedIdentity.displayName;
    }
  }

  SetIdentity = (displayName: string, token: string):void => {
    this._isAuthenticated.value = true;
    this._displayName = displayName;
    this._token = token;
    this.SetClaims(token);

    this.storeLocal();
  }

  Discard = (): void => {
    this._isAuthenticated.value = false;
    this._displayName = null;
    this._token = null;
    this._claims = null;

    localStorage.removeItem("identity");
  }

  get IsAuthenticated(): boolean {
    return this._isAuthenticated.value;
  }

  get DisplayName(): string {
    return this._displayName;
  }

  get Token(): string {
    return this._token;
  }

  get Claims(): ITokenClaims {
    return this._claims;
  }

  get IsAdmin(): boolean {
    return this.Claims.role == 'Admin';
  };
  
  get IsBerater(): boolean {
    return this.Claims.role == 'Berater';
  };

  get IsAuditor(): boolean {
    return this.IsAdmin || this.IsBerater;
  };

  get HasSelectedStandort(): boolean {
    return this.Claims.standortId != null && this.Claims.standortId != '';
  }
  

  private SetClaims(encrypted: string) {
    var base64 = encrypted.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    var payload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    this._claims = JSON.parse(payload) as ITokenClaims;
  }
}

export const useIdentity = () => {
  const Identity = inject(IdentitySymbol) as IIdentity

  return {
    Identity
  }
}